/* cn-carousel.js — shared carousel behavior over a NATIVE scroll-snap track.
   Swiping, snapping and momentum are the browser's; this module only keeps
   the dots in step with the track and lets a dot scroll to its slide.
   Contract:
     [data-cn-carousel]               root; must contain ONLY its own slides
       [data-cn-carousel-track]       the scrolling element
         [data-cn-slide]              each slide (direct or nested)
       [data-cn-carousel-dot]         optional; one per slide, in slide order
   State set by this module (style it, do not guess it):
     dot[aria-current="true"]         the dot of the slide nearest the start
   When the track does not overflow (e.g. the section lays it out as a static
   grid at a breakpoint), no scroll events fire and the module is inert.
   Extend here with data-cn-* options that no-op when absent — never fork. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.__cnCarousel) return;
    var track = root.querySelector('[data-cn-carousel-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-cn-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cn-carousel-dot]'));
    if (!slides.length) return;
    var frame = 0;

    function offsetOf(slide) {
      return slide.getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
    }

    function currentIndex() {
      var max = track.scrollWidth - track.clientWidth;
      if (max > 0 && track.scrollLeft >= max - 2) return slides.length - 1;
      var best = 0;
      var bestDistance = Infinity;
      slides.forEach(function (slide, i) {
        var distance = Math.abs(offsetOf(slide) - track.scrollLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      });
      return best;
    }

    function update() {
      frame = 0;
      var index = currentIndex();
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function onScroll() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function onClick(e) {
      var dot = e.target.closest('[data-cn-carousel-dot]');
      if (!dot) return;
      var index = dots.indexOf(dot);
      if (index < 0 || !slides[index]) return;
      track.scrollTo({ left: offsetOf(slides[index]), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    root.addEventListener('click', onClick);
    window.addEventListener('resize', onScroll);
    update();

    root.__cnCarousel = {
      destroy: function () {
        if (frame) window.cancelAnimationFrame(frame);
        track.removeEventListener('scroll', onScroll);
        root.removeEventListener('click', onClick);
        window.removeEventListener('resize', onScroll);
        delete root.__cnCarousel;
      }
    };
  }

  function initAll(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cn-carousel]'), init);
  }

  function destroyAll(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cn-carousel]'), function (root) {
      if (root.__cnCarousel) root.__cnCarousel.destroy();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    destroyAll(e.target);
  });
})();
